export const selectCountries = {
  selectCountries: {
    label: 'Country',
    placeholder: 'Select a Country',
  },
};
